import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { AttachmentType } from '../attachment-type'
import { Injectable, inject } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class AttachmentTypeService extends RestClientPaged<AttachmentType, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/attachment-types', http, {
      idField: 'id',
    })
  }
}
